import { view } from "@risingstack/react-easy-state";
import cn from "classnames";
import { isNumber } from "lodash-es";

import type { Product } from "../../common/types/productTypes";
import { formatPrice, formatUnit } from "../../common/utils";

import authStore from "../../stores/auth/authStore";
import { hasDiscount } from "../../stores/product/productUtils";

import PricePerItem from "../../components/PricePerItem";
import theme from "../../themes/theme";

type DisplayPricePdpProps = {
   product: Product;
};

const DisplayPricePdp = ({ product }: DisplayPricePdpProps) => {
   if (!authStore.isLoggedIn()) {
      return null;
   }

   return (
      <div className="tw-pb-2">
         {hasDiscount(product) && (
            <div className="tw-mb-2">
               <strong className="tw-line-through tw-opacity-50">{formatPrice(product.priceBeforeDiscount)}</strong>
            </div>
         )}
         <div className={cn("tw-mb-2", { "tw-text-promotion": hasDiscount(product) })}>
            <strong className="tw-text-xl">{formatPrice(product.price)}</strong> {formatUnit(product.unit || "STK", false)}
         </div>
         <PricePerItem className={cn("tw-mb-2 tw-text-sm", { "tw-text-promotion": hasDiscount(product) })} product={product} />
         {isNumber(product.comparisonPrice) && theme.showComparisonPrice && !!product.comparisonUnit && (
            <div className={cn("tw-mb-2 tw-text-sm", { "tw-text-promotion": hasDiscount(product) })}>
               {formatPrice(product.comparisonPrice)} per {product.comparisonUnit.toLowerCase()}
            </div>
         )}
      </div>
   );
};

export default view(DisplayPricePdp);
